import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(source, true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source)).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import { Field as ReactField } from '@rexlabs/react-forms';
import { styled, StyleSheet } from '@rexlabs/styling';
import { noop } from 'lodash';
var defaultStyles = StyleSheet({
  field: {
    width: '100%',
    marginTop: '0.25rem'
  },
  fieldLabel: {
    marginBottom: '0.5rem'
  },
  inlineField: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none'
  },
  inlineFieldInput: {
    width: '100%'
  },
  inlineFieldLabel: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginLeft: '0.5rem',
    cursor: 'pointer'
  },
  error: {
    color: 'red'
  }
});
var InnerField = (_dec = styled(defaultStyles), _dec(_class = autobind(_class =
/*#__PURE__*/
function (_Component) {
  _inherits(InnerField, _Component);

  function InnerField() {
    _classCallCheck(this, InnerField);

    return _possibleConstructorReturn(this, _getPrototypeOf(InnerField).apply(this, arguments));
  }

  _createClass(InnerField, [{
    key: "createFakeEvent",
    value: function createFakeEvent(value) {
      var field = this.props.field;
      return {
        persist: noop,
        target: {
          type: 'checkbox',
          name: field.name,
          id: field.name,
          value: value,
          checked: value
        }
      };
    }
  }, {
    key: "handleLabelClick",
    value: function handleLabelClick() {
      var field = this.props.field;
      var fakeEvent = this.createFakeEvent(!field.value);
      field.onChange(fakeEvent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          s = _this$props.styles,
          label = _this$props.label,
          field = _this$props.field,
          meta = _this$props.meta,
          isInlineLabel = _this$props.isInlineLabel,
          innerFieldProps = _this$props.innerFieldProps;
      var inputProps = innerFieldProps.inputProps,
          FieldComponent = innerFieldProps.FieldComponent,
          FieldLabel = innerFieldProps.FieldLabel,
          FieldError = innerFieldProps.FieldError;

      var fieldComponentProps = _objectSpread({}, inputProps, {}, field, {
        meta: meta
      });

      return React.createElement("div", _extends({}, s('field'), {
        "data-form-field-name": field.name
      }), isInlineLabel && React.createElement("div", s('inlineField'), React.createElement(FieldComponent, fieldComponentProps), React.createElement(FieldLabel, _extends({}, s('inlineFieldLabel'), {
        onClick: this.handleLabelClick
      }), label)), !isInlineLabel && React.createElement(FieldLabel, s('fieldLabel'), label), !isInlineLabel && React.createElement(FieldComponent, fieldComponentProps), meta.touched && meta.error && React.createElement(FieldError, s('error'), meta.error));
    }
  }]);

  return InnerField;
}(Component)) || _class) || _class);

var Field =
/*#__PURE__*/
function (_Component2) {
  _inherits(Field, _Component2);

  function Field() {
    _classCallCheck(this, Field);

    return _possibleConstructorReturn(this, _getPrototypeOf(Field).apply(this, arguments));
  }

  _createClass(Field, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          Input = _this$props2.Input,
          inputProps = _this$props2.inputProps,
          FieldLabel = _this$props2.FieldLabel,
          FieldError = _this$props2.FieldError,
          children = _this$props2.children,
          rest = _objectWithoutProperties(_this$props2, ["Input", "inputProps", "FieldLabel", "FieldError", "children"]);

      var FieldComponent = Input;
      var innerFieldProps = {
        inputProps: inputProps,
        FieldComponent: FieldComponent,
        FieldLabel: FieldLabel,
        FieldError: FieldError
      };
      return React.createElement(ReactField, _extends({}, rest, {
        Component: InnerField,
        innerFieldProps: innerFieldProps
      }));
    }
  }]);

  return Field;
}(Component);

_defineProperty(Field, "propTypes", {
  name: PropTypes.string,
  label: PropTypes.string,
  isInlineLabel: PropTypes.bool,
  inputProps: PropTypes.object,
  Input: PropTypes.elementType,
  FieldLabel: PropTypes.elementType,
  FieldError: PropTypes.elementType,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
});

_defineProperty(Field, "defaultProps", {
  isInlineLabel: false,
  Input: 'input',
  inputProps: {},
  FieldLabel: 'label',
  FieldError: 'div'
});

export default Field;